import { AgentComponentType } from '@reach/shared-types/agent-components';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { agentBuilderNestedRoutes, appRoutes, buildAgentToolPath } from '../../app-routes';
import { FlagProtectedRoute } from '../../components/FlagProtectedRoute';
import { ToolEditPage } from '../ai-tools';
import { AgentsNav } from './agents-nav';
import styles from './AgentBuilder.module.css';
import { ComponentListPage } from './component-list';
import { ComponentPage } from './component-page';
import { AgentsOverview } from './overview';
import { VoiceTemplatePage } from './template-page';
import { TenantPreviewPage } from './tenant-preview-page';
import { ToolListPage } from './tool-list';

const COMPONENT_SECTIONS = [
  { type: AgentComponentType.SKILL, path: agentBuilderNestedRoutes.SKILLS },
  { type: AgentComponentType.GUIDANCE, path: agentBuilderNestedRoutes.GUIDANCE },
  { type: AgentComponentType.ESCALATION, path: agentBuilderNestedRoutes.ESCALATIONS },
];

const BUILDER_TOOL_ROUTES = { list: appRoutes.AGENT_TOOLS, tool: buildAgentToolPath };

/** The partner's agent builder: its own navigation beside the section being viewed. */
export const AgentBuilder = () => (
  <div className={styles.builder}>
    <AgentsNav />
    <div className={styles.section}>
      <Routes>
        <Route index element={<AgentsOverview />} />
        <Route path={agentBuilderNestedRoutes.VOICE_TEMPLATE}>
          <Route index element={<VoiceTemplatePage />} />
          <Route path={agentBuilderNestedRoutes.TENANT_PREVIEW} element={<TenantPreviewPage />} />
        </Route>
        {COMPONENT_SECTIONS.map(({ type, path }) => (
          <Route key={type} path={path}>
            <Route index element={<ComponentListPage type={type} />} />
            <Route
              path={agentBuilderNestedRoutes.NEW_COMPONENT}
              element={<ComponentPage type={type} />}
            />
            <Route path={agentBuilderNestedRoutes.COMPONENT} element={<ComponentPage type={type} />} />
          </Route>
        ))}
        <Route
          path={agentBuilderNestedRoutes.TOOLS}
          element={
            <FlagProtectedRoute flag="enable-partner-mcp-authoring" redirectTo={appRoutes.AGENTS}>
              <Outlet />
            </FlagProtectedRoute>
          }>
          <Route index element={<ToolListPage />} />
          <Route
            path={agentBuilderNestedRoutes.NEW_TOOL}
            element={<ToolEditPage routes={BUILDER_TOOL_ROUTES} />}
          />
          <Route
            path={agentBuilderNestedRoutes.TOOL}
            element={<ToolEditPage routes={BUILDER_TOOL_ROUTES} />}
          />
        </Route>
        <Route path="*" element={<Navigate to={appRoutes.AGENTS} replace />} />
      </Routes>
    </div>
  </div>
);
